/**
 * Turn a failed create-lead response into a sentence an operator can act on,
 * instead of dumping raw JSON.stringify(response.data) into a toast.
 */
const FIELD_LABELS = {
    first_name: 'First name',
    last_name: 'Last name',
    dob: 'Date of birth',
    salutation: 'Title',
    sex: 'Gender',
    phone: 'Phone number',
    email: 'Email',
    postcode: 'Postcode',
    lead_contact: 'Contact details',
    lead_address: 'Address',
    lead_source: 'Lead source',
    lead_treatments: 'Treatment',
    non_field_errors: '',
};

export const CREATE_LEAD_ERROR_FALLBACK = 'Could not create the lead. Please check the details and try again.';

const flatten = (value, label, out, depth = 0) => {
    if (value == null || depth > 3) return;
    if (typeof value === 'string') {
        out.push(label ? `${label}: ${value}` : value);
    } else if (Array.isArray(value)) {
        value.forEach((v) => flatten(v, label, out, depth + 1));
    } else if (typeof value === 'object') {
        Object.entries(value).forEach(([k, v]) => {
            const next = k in FIELD_LABELS ? FIELD_LABELS[k] : k.replace(/_/g, ' ');
            flatten(v, depth === 0 || !label ? next : label, out, depth + 1);
        });
    }
};

export function friendlyCreateLeadError(response) {
    const status = response?.status;
    if (status === 403) return 'You do not have permission to create leads for this practice.';
    if (status === 429) return 'Too many requests. Please wait a moment and try again.';
    if (status >= 500) return 'The server had a problem creating this lead. Please try again in a moment.';
    const data = response?.data;
    if (status === 409 && data?.code === 'lead_identity_match') {
        return 'This patient already exists in your CRM. Search for them or choose how to continue.';
    }
    if (typeof data === 'string' && data.trim() && !data.trim().startsWith('<')) return data.trim().slice(0, 200);
    if (data?.detail && typeof data.detail === 'string') return data.detail;
    const messages = [];
    flatten(data, '', messages);
    const unique = [...new Set(messages.filter(Boolean))];
    return unique.length ? unique.slice(0, 3).join(' · ') : CREATE_LEAD_ERROR_FALLBACK;
}
